// sound.js
let audio = null;

export const initAudio = () => {
  audio = new Audio("/sounds/notification.mp3");

  // unlock audio on first user interaction
  const unlock = () => {
    audio
      .play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
      })
      .catch(() => {});

    document.removeEventListener("click", unlock);
  };

  document.addEventListener("click", unlock);
};

export default function playSound() {
  if (!audio) return;

  audio.currentTime = 0;
  audio.play().catch((err) => {
    console.log("audio err", err);
  });
}
